import {
   SegmentedControl as MantineSegmentedControl,
   SegmentedControlProps as MantineSegmentedControlProps,
} from '@mantine/core'

export const SegmentControl = ({ ...props }: MantineSegmentedControlProps) => {
   return (
      <MantineSegmentedControl
         classNames={{
            root: 'p-0 rounded-lg border border-white/10 !bg-white/[0.02]',
            label: 'text-white rounded-lg px-6 py-2',
            indicator: '!bg-white/[0.04] rounded-lg border border-white/10',
            control: '!rounded-lg !bg-transparent',
            input: 'border border-white/10'
         }}
         {...props}
      />
   )
}
